import PropTypes from "prop-types";
import React from "react";

const Camera = (props) => (
  <svg
    height={24}
    viewBox="0 0 28 24"
    width={28}
    fill="currentColor"
    {...props}
    style={{
      verticalAlign: "middle",
      color: props.color,
      ...props.style,
    }}
  >
    <g
      id="Journey-8---Settings"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="4.4--email---replace-image"
        transform="translate(-753.000000, -399.000000)"
        fill="#333333"
        fillRule="nonzero"
      >
        <g id="camera" transform="translate(753.000000, 399.000000)">
          <path
            d="M23.7995035,4.22292581 L22.0075409,4.22292581 L21.5595502,2.81530488 C20.9642943,1.12242424 19.3694274,-0.00685890543 17.5836332,6.29982151e-05 L10.4157827,6.29982151e-05 C8.61161958,0.0034566811 7.01118181,1.1650151 6.43986565,2.88568592 L5.99187499,4.29330686 L4.19991238,4.29330686 C1.88036482,4.29330686 6.21711923e-16,6.18394694 0,8.51616968 L0,19.7771372 C6.21711923e-16,22.1093599 1.88036482,24 4.19991238,24 L23.7995035,24 C26.119051,24 27.9994159,22.1093599 27.9994159,19.7771372 L27.9994159,8.51616968 C28.0181845,7.38405245 27.5839946,6.29178085 26.7943148,5.48455259 C26.004635,4.67732433 24.9256243,4.22276854 23.7995035,4.22292581 Z M25.1994743,19.7067561 C25.1994743,20.4841637 24.572686,21.1143771 23.7995035,21.1143771 L4.19991238,21.1143771 C3.42672986,21.1143771 2.79994159,20.4841637 2.79994159,19.7067561 L2.79994159,8.44578863 C2.79994159,7.66838105 3.42672986,7.03816769 4.19991238,7.03816769 L6.99985396,7.03816769 C7.62725418,7.07109401 8.19963744,6.67974649 8.39982476,6.08098545 L9.15580899,3.77248711 C9.34840593,3.19914661 9.88391152,2.81374275 10.4857812,2.81530488 L17.6536317,2.81530488 C18.2555014,2.81374275 18.791007,3.19914661 18.983604,3.77248711 L19.7395882,6.08098545 C19.9234487,6.6304981 20.4235968,7.01045275 20.9995619,7.03816769 L23.7995035,7.03816769 C24.572686,7.03816769 25.1994743,7.66838105 25.1994743,8.44578863 L25.1994743,19.7067561 Z M13.9997079,7.03816769 C10.9069779,7.03816769 8.39982476,9.55902113 8.39982476,12.6686514 C8.39982476,15.7782818 10.9069779,18.2991352 13.9997079,18.2991352 C17.092438,18.2991352 19.5995911,15.7782818 19.5995911,12.6686514 C19.5995911,11.1753543 19.0096051,9.74321873 17.9594233,8.6872982 C16.9092415,7.63137767 15.4848893,7.03816769 13.9997079,7.03816769 Z M13.9997079,15.4838933 C12.4533429,15.4838933 11.1997663,14.2234666 11.1997663,12.6686514 C11.1997663,11.1138363 12.4533429,9.85340957 13.9997079,9.85340957 C15.546073,9.85340957 16.7996495,11.1138363 16.7996495,12.6686514 C16.7996495,14.2234666 15.546073,15.4838933 13.9997079,15.4838933 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

Camera.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
};

export default Camera;
